import { Text, Wrapper } from '@setplex/arcane'

SignUpInfoBlock.displayName = 'SignUpInfoBlock'
export function SignUpInfoBlock() {
  return (
    <Wrapper className='sign-up-info-text-block wrapper--column wrapper--row-gap--indents-0 wrapper--align-items-start'>
      <Text
        className='sign-up-info-block-title text--fonts-subtitle-sm-bold text--color-on-surface-1'
        text='Why is UVOtv asking for my age?'
      />
      <Text
        className='sign-up-info-block-description text--fonts-body-sm-medium text--color-text-secondary'
        text="Asking for a user's age is a method used by companies to determine whether a user meets certain age requirements, typically set out in the company's terms of use, in a way that's consistent with industry, legal, and regulatory guidelines and requirements. For example, it helps avoid showing content or advertisements not suitable for minors (e.g. like alcohol ads)."
      />

      <Text
        className='sign-up-info-block-title text--fonts-subtitle-sm-bold text--color-on-surface-1'
        text='Why is UVOtv asking for my gender?'
      />
      <Text
        className='sign-up-info-block-description text--fonts-body-sm-medium text--color-text-secondary'
        text='This information, similar to above, is used by UVOtv to create customized experience for users.'
      />
    </Wrapper>
  )
}
